import * as React from 'react';
import { FormNumberInput } from '../form-number-input/FormNumberInput';

export type FormInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
	increment?: number;
};

interface ITextProps extends FormInputProps {
	displaytextcounter?: 'true' | 'false';
	widthtype?: 'narrow' | 'half' | 'normal' | 'wide' | 'full';
	'is-valid'?: 'true' | 'false';
}

export const FormInput = (props: ITextProps) => {
	const { type, widthtype, readOnly, minLength, maxLength, value, } = props;

	if (type === 'number') {
		return <FormNumberInput {...props} />;
	}

	const displayTextCounter = props.displaytextcounter === 'true';
	const isValid = props['is-valid'] !== 'false';
	const containerClassList = ['form__input--container', `form__input--container--${type}`];

	if (widthtype) {
		containerClassList.push(`form__input--container--${widthtype}`);
	} else {
		containerClassList.push('container');
	}

	const classList = ['form__input'];

	if (type) {
		classList.push(`form__input--${type}`);
	}

	if (!isValid) {
		classList.push('form__input--error');
	}

	if (readOnly) {
		classList.push('form__input--readonly');
	}

	const minText = <React.Fragment>
		{(minLength !== undefined) &&
			<span> (minimum <span className="form_input--text--counter--min_length">{minLength}</span>)</span>}
	</React.Fragment>;

	const maxText = <React.Fragment>
		{(maxLength !== undefined) && <span>/<span className="form_input--text--counter--max_length">{maxLength}</span></span>}
	</React.Fragment>;

	const countText = <span className="form_input--text--counter--current_length">{(value as string || []).length}</span>;

	return <div className={containerClassList.join(' ')}>
		<input className={classList.join(' ')} {...props} />
		{displayTextCounter ? <div className="form_input--text--counter">
			<p>{minText} {countText}{maxText}</p>
		</div> : null}
	</div >;
};
